import { render } from "./StudentChoiceHeader.vue?vue&type=template&id=79d95c93&scoped=true&ts=true"
import script from "./StudentChoiceHeader.vue?vue&type=script&lang=ts"
export * from "./StudentChoiceHeader.vue?vue&type=script&lang=ts"

import "./StudentChoiceHeader.vue?vue&type=style&index=0&id=79d95c93&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d95c93"]])

export default __exports__